import {
	type Action,
	type BoundActions,
	createActionsHook,
	createHook,
	createStore,
	type HookActionsFunction,
	type HookFunction,
} from 'react-sweet-state';

type RovoChatHighlightActionsState = {
	isMoreOptionsPopupOpen: boolean;
};

type RovoChatHighlightActionsAction = Action<RovoChatHighlightActionsState>;
type RovoChatHighlightActionsActions = {
	setIsMoreOptionsPopupOpen: (isOpen: boolean) => RovoChatHighlightActionsAction;
};

const store = createStore<RovoChatHighlightActionsState, RovoChatHighlightActionsActions>({
	name: 'RovoChatHighlightActionsStore',
	initialState: {
		isMoreOptionsPopupOpen: false,
	},
	actions: {
		setIsMoreOptionsPopupOpen:
			(isOpen: boolean) =>
			({ setState }) => {
				setState({
					isMoreOptionsPopupOpen: isOpen,
				});
			},
	},
});

export const useRovoChatHighlightActions: HookFunction<
	RovoChatHighlightActionsState,
	BoundActions<RovoChatHighlightActionsState, RovoChatHighlightActionsActions>,
	void
> = createHook(store);
export const useRovoChatHighlightActionsActions: HookActionsFunction<
	BoundActions<RovoChatHighlightActionsState, RovoChatHighlightActionsActions>
> = createActionsHook(store);
